import HelpCircle from 'assets/svg/icons/HelpCircle';
import cn from 'classnames';
import { Helper } from 'components/molecules/Helper';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { AIAgentEnum } from 'types/ai.types';
import type { UserAiUsageConsentEnum } from 'types/users.types';
import { InformationCircleIconOutline } from 'utils/icons';
import { useAIChatContext } from './AIChat.context';

type DataShareConfig = {
  [key in AIAgentEnum]: {
    [key in UserAiUsageConsentEnum]?: string[];
  };
};

const dataShareConfig: DataShareConfig = {
  default: {
    limited: ['occupation', 'vat_type'],
    allow: [
      'occupation',
      'vat_type',
      'aggregated_data',
      'tax_deadlines',
      'start_date',
    ],
  },
  email_writer: {
    allow: ['occupation', 'current_email'],
  },
  wrapped_advisor: {
    allow: [
      'occupation',
      'vat_type',
      'aggregated_data',
      'tax_deadlines',
      'start_date',
    ],
  },
};

type AIChatDataShareModalProps = {
  showIcon?: boolean;
  className?: string;
  title?: string;
};

const AIChatDataShareModal: FC<AIChatDataShareModalProps> = ({
  showIcon,
  className,
  title,
}) => {
  const { aiAgent, usage } = useAIChatContext();
  const { t } = useTranslation();

  const dataShareList = dataShareConfig[aiAgent][usage.consent];
  if (!dataShareList) return null;
  // TODO: retranslate ai_bot.data_share.helper.title
  return (
    <Helper
      hideAI
      name="AI Data Share"
      trigger={(open) => (
        <button
          className={cn(
            'flex gap-1 hover:underline justify-center items-center text-primary-400 hover:text-primary-300 text-sm',
            { 'mx-auto': showIcon },
            className,
          )}
          onClick={open}
        >
          {showIcon && <InformationCircleIconOutline className="w-5" />}
          <span>{title || t('ai_bot.data_share.helper.title')}</span>
          {!showIcon && <HelpCircle className="w-5" />}
        </button>
      )}
    >
      <Helper.Title>{t('ai_bot.data_share.helper.title')}</Helper.Title>
      <Helper.Paragraph>
        {t('ai_bot.data_share.helper.subtitle')}
      </Helper.Paragraph>

      <Helper.Paragraph>
        {dataShareList.map((key) => (
          <p key={key}>- {t(`ai_bot.data_share.${key}`)}</p>
        ))}
      </Helper.Paragraph>

      <Helper.Paragraph>
        {t('ai_bot.data_share.helper.no_personal_data')}
      </Helper.Paragraph>
    </Helper>
  );
};

export default AIChatDataShareModal;
